// extracted by css-extract-rspack-plugin
export default {"input":"input__TbKNx","icon":"icon__xTHdu"};